import { Injectable } from '@angular/core';
import { HttpService } from '../http-service/http.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class OnlineInterfaceService {
  constructor(private http: HttpService,private customHttp: HttpClient) { }


  login = (username, password, token) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('login', {
        username,
        password,
        token
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  changeOwnerFacility = (token, facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('changeOwnerFacility', {
        token,
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getFacilitiesList = (country) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getFacilitiesList', {
        country: country
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }
  
  getCountriesList = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getCountryList', {
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  logout = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('backofficeLogout', {
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data[0]);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  changePassword = (ownerId, oldPassword, newPassword) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('changePassword', {
        ownerId,
        oldPassword,
        newPassword
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- Padel Getters -----------------//
  
  getDashboardStatistics = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getDashboardBO', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getBookings = (facilityId, pageNo, noOfRecords) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getBookings', {
        facilityId,
        pageNo,
        noOfRecords
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }
  getBookingsClasses = (facilityId, pageNo, noOfRecords) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getBookingsClasses', {
        facilityId,
        pageNo,
        noOfRecords
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getBookingStatus = (mobile,countryCode) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getBookingStatus', {
        mobile,
        countryCode
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }
  getBookingsById = (bookingId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getBookingsById', {
        bookingId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getBookingsCalendar = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getBookingsCalendar', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }



  getBookingsCalendarHistory = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getBookingsCalendarHistory', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getCourtsCalendar = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getCourtsCalendar', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getDisabledCalendar = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getDisabledCalendar', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getPaymentMethods = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getPaymentMethods', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getTimingSlots = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getTimingSlots', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getCourts = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getCourtsTable', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getBookingCategory = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getBookingCategoryTable', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getUserTypes = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getUserTypes', {
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getOffers = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getOffersTable', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getDisabled = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getDisabledTable', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getCoachDisabled = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getCoachDisabledTable', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getAddonsTable = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getAddonsTable', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }
  
  getAddons = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getAddons', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getOwners = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getOwnersTable', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getOwnersList = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getOwnersList', {
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getActiveUsers = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getActiveUsers', {
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getActiveFacilities = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getActiveFacilities', {
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getActiveFacilitiesBranches = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getActiveFacilitiesBranches', {
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getTapFacilityFiles = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getTapFacilityFiles', {
        facilityId: facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }
  
  getUsers = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getUsersTable', {
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getUsersFacility = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getUsersFacilityTable', {
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getCoachesByFacility = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getCoachesByFacility', {
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getCoaches = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getCoachesTable', {
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getCoachPackages = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getCoachPackagesTable', {
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getCoachPrice = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getCoachPriceTable', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  
  getCustomer = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getCustomerTable', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getPayments = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getPaymentTable', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getReports = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getReportsTable', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getInvistigations = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getInvistigationTable', {
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateMatchResultStatus = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateMatchResultStatus', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateInvistigation = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('investigationDecision', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getInvistigationActions = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getInvistigationActions', {
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getMatchResults = (matchId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getMatchResults', {
        matchId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getMatchPlayers = (matchId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getMatchPlayers', {
        matchId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getClassPlayers = (classId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getClassPlayers', {
        classId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getReportsAllChannels = (facilityId, paymentMonth) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getReportsAllChannels', {
        facilityId, paymentMonth
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getPromotion = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getPromotionTable', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getPromotionConfig = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getPromotionConfigTable', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getPromotionAdmin = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getPromotionAdminTable', {
        facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getFacilities = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getFacilityTable', {
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getFacilitiesPaymentMethod = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getFacilityPaymentMethodsTable', {
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getCoachesPaymentMethod = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getCoachPaymentMethodsTable', {
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getFacilityPaymentMethods = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getFacilityPaymentMethods', {
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getCoachPaymentMethods = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getCoachPaymentMethods', {
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getFacilitySchedule = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getFacilityScheduleTable', {
        facilityId: facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getFacilityTiming = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getFacilityTimingTable', {
        facilityId: facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getFacilityImages = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getFacilityImagesTable', {
        facilityId: facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getTapFiles = () => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getTapFacilityFileTable', {
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getTapOnboarding = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getTapFacilityOnboardingTable', {
        facilityId: facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getTapFilePurpose = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getTapFilePurpose', {
        facilityId: facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }


  getFacilityEvent = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getFacilityEventTable', {
        facilityId: facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getBookingReoccur = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getBookingReoccurTable', {
        facilityId: facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }
  addBookingReoccurActual = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addBookingActualReoccurTable', {
        facilityId: facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getMembership = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getMembershipTable', {
        facilityId: facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getMembershipAddonsByUser = (facilityId, mobile, countryCode) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getMembershipAddonByUser', {
        facilityId: facilityId,
        mobile: mobile,
        countryCode: countryCode
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getMembershipList = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getMembershipForFacility', {
        facilityId: facilityId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getOwnerFacilityList = (ownerId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getOwnerFacilitiesList', {
        ownerId: ownerId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getCustomerInfo = (mobile, countryCode) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getCustomerInfo', {
        mobile: mobile,
        countryCode: countryCode
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- Padel CRUD -----------------//

  //--------------- Court -----------------//

  addCourt = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addCourtsTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateCourt = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateCourtsTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteCourt = (courtId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteCourtsTable', { 
        courtId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- BookingCategory -----------------//

  addBookingCategory = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addBookingCategoryTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateBookingCategory = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateBookingCategoryTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteBookingCategory = (bookingCategoryId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteBookingCategoryTable', { 
        bookingCategoryId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- Facility Payment Methods -----------------//

  addFacilityPaymentMethods = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addFacilityPaymentMethodsTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateFacilityPaymentMethods = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateFacilityPaymentMethodsTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteFacilityPaymentMethods = (facilityPaymentMethodId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteFacilityPaymentMethodsTable', { 
        facilityPaymentMethodId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- Coach Payment Methods -----------------//

  addCoachPaymentMethods = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addCoachPaymentMethodsTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateCoachPaymentMethods = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateCoachPaymentMethodsTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteCoachPaymentMethods = (coachPaymentMethodId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteCoachPaymentMethodsTable', { 
        coachPaymentMethodId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- Facility Schedule -----------------//

  addFacilitySchedule = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addFacilityScheduleTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateFacilitySchedule = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateFacilityScheduleTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteFacilitySchedule = (facilityScheduleId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteFacilityScheduleTable', { 
        facilityScheduleId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- Facility Timing -----------------//

  addFacilityTiming = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addFacilityTimingTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateFacilityTiming = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateFacilityTimingTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteFacilityTiming = (facilityTimingId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteFacilityTimingTable', { 
        facilityTimingId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- Booking Reoccur -----------------//

  addBookingReoccur = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addBookingReoccurTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateBookingReoccur = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateBookingReoccurTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteBookingReoccur = (bookingReoccurId,bookingFixedId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteBookingReoccurTable', { 
        bookingReoccurId,bookingFixedId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getBookingFixedClassTable = (bookingFixedId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getBookingFixedClassTable', { 
        bookingFixedId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- Facility Images -----------------//

  addFacilityImages = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addFacilityImagesTable', fields, true)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateFacilityImages = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateFacilityImagesTable', fields, true)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteFacilityImages = (facilityImageId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteFacilityImagesTable', { 
        facilityImageId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- Facility Event -----------------//

  addFacilityEvent = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addFacilityEventTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateFacilityEvent = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateFacilityEventTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteFacilityEvent = (facilityEventId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteFacilityEventTable', { 
        facilityEventId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- Addon -----------------//

  addAddon = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addAddonsTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateAddon = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateAddonsTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteAddon = (addonId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteAddonsTable', { 
        addonId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- User -----------------//

  addUser = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addUsersTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateUser = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateUsersTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteUser = (userId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteUsersTable', { 
        userId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

    //--------------- User -----------------//

  addUserFacility = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addUsersFacilityTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateUserFacility = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateUsersFacilityTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteUserFacility = (userId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteUsersFacilityTable', { 
        userId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }
 
  //--------------- Coach -----------------//

  addCoach = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addCoachTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateCoach = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateCoachTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteCoach = (coachId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteCoachTable', { 
        coachId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- Coach Packages -----------------//

  addCoachPackage = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addCoachPackageTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateCoachPackage = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateCoachPackageTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteCoachPackage = (coachPackageId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteCoachPackageTable', { 
        coachPackageId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- Customer -----------------//

  addCustomer = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addCustomerTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateCustomer = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateCustomerTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteCustomer = (customerId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteCustomerTable', { 
        customerId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- Owner -----------------//

  addOwner = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addOwnersTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateOwner = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateOwnersTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteOwner = (ownerId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteOwnersTable', { 
        ownerId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteBooking = (bookingId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteBooking', { 
        bookingId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  markBookingNoShow = (bookingId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('markBookingNoShow', { 
        bookingId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }


  //--------------- Offer -----------------//

  addOffer = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addOffersTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateOffer = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateOffersTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteOffer = (offerId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteOffersTable', { 
        offerId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- Coach Price Offer -----------------//

  addCoachPrice = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addCoachPriceTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateCoachPrice = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateCoachPriceTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteCoachPrice = (coachPriceId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteCoachPriceTable', { 
        coachPriceId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- Disabled -----------------//

  addDisabled = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addDisabledTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateDisabled = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateDisabledTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteDisabled = (disabledId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteDisabledTable', { 
        disabledId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- Disabled -----------------//

  addCoachDisabled = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addCoachDisabledTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateCoachDisabled = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateCoachDisabledTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteCoachDisabled = (disabledId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteCoachDisabledTable', { 
        disabledId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- Promotion -----------------//

  addPromotion = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addPromotionTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updatePromotion = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updatePromotionTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deletePromotion = (promotionId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deletePromotionTable', { 
        promotionId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- Promotion Configuration -----------------//

  addPromotionConfig = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addPromotionConfigTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updatePromotionConfig = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updatePromotionConfigTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deletePromotionConfig = (promotionConfigId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deletePromotionConfigTable', { 
        promotionConfigId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- Promotion -----------------//

  addPromotionAdmin = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addPromotionAdminTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updatePromotionAdmin = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updatePromotionAdminTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deletePromotionAdmin = (promotionId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deletePromotionAdminTable', { 
        promotionId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  //--------------- Membership -----------------//

  addMembership = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addMembershipTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateMembership = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateMembershipTable', fields, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteMembership = (facilityMembershipUserId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteMembershipTable', { 
        facilityMembershipUserId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

    //--------------- Facility -----------------//

    addFacility = (fields) => {
      return new Promise<any>(async (resolve, reject) => {
        await this.http.post('addFacilityTable', fields, false)
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
      });
    }
  
    updateFacility = (fields) => {
      return new Promise<any>(async (resolve, reject) => {
        await this.http.post('updateFacilityTable', fields, false)
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
      });
    }
  
    deleteFacility = (facilityId) => {
      return new Promise<any>(async (resolve, reject) => {
        await this.http.post('deleteFacilityTable', { 
          facilityId 
        }, false)
        .then(res => {
          const data: any = res;
          resolve(data);
        })
        .catch(async err => {
          reject(err);
        });
      });
    }

  deleteTransaction = (paymentId, bookingId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteTransaction', { 
        paymentId, bookingId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  confirmOfflinePayment = (paymentId, bookingId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('confirmOfflinePayment', { 
        paymentId, bookingId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  addNewPayment = (facilityId, courtId, bookingId, ccy, paidAmount, paymentCode, selectedPlayer) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addNewPayment', {
        facilityId, courtId, bookingId, ccy, paidAmount, paymentCode, selectedPlayer
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  refundPayment = (paymentId,sharedWallet) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('refundBookingPayment', {
        paymentId,
        sharedWallet
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  removeClassPlayer = (playerId,classId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('removeClassPlayer', {
        playerId,classId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  
  removeMatchPlayer = (playerId,matchId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('removeMatchPlayer', {
        playerId,matchId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  createMatch = (bookingId, matchType, category, requestToJoin, isPrivate, facilityId, noOfSets, userId, player1ACountryCode, player1AMobile,
    player2ACountryCode, player2AMobile, player1BCountryCode, player1BMobile, player2BCountryCode, player2BMobile, matchNotes) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('createMatchBackoffice', {
        bookingId, matchType, category, requestToJoin, isPrivate, facilityId, noOfSets, userId, player1ACountryCode, player1AMobile,
        player2ACountryCode, player2AMobile, player1BCountryCode, player1BMobile, player2BCountryCode, player2BMobile, matchNotes
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }
  cancelMatch = (userId, matchId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('cancelMatchBackoffice', {
        userId, matchId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  createClass = (bookingId, 
    facilityId, 
    coachId, 
    noOfPlayers, 
    classPrice,
    classCcy, 
    staffId,
    showInApp) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addClass', {
        bookingId, 
        facilityId, 
        coachId, 
        noOfPlayers, 
        classPrice,
        classCcy, 
        staffId,
        showInApp
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }
  cancelClass = (userId, classId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('cancelClass', {
        userId, classId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }
  addClassPlayer = (userId, classId, mobile,countryCode,classPlayerPaymentMethod,showInApp,name) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addClassPlayer', {
        userId, classId, mobile,countryCode,classPlayerPaymentMethod,showInApp,name
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  addMatchPlayer = (userId, matchId, mobile,countryCode,matchPlayerPaymentMethod,selectedTeam,name) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addMatchPlayer', {
        userId, matchId, mobile,countryCode,matchPlayerPaymentMethod,selectedTeam,name
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  cancelRecurrantBooking = (staffId,bookingId,bookingDisabledDate) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('cancelRecurrantBooking', {
        staffId, bookingId, bookingDisabledDate
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }
  sendVerifyOTP = (countryCode,mobile) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('sendVerifyOTP', {
        countryCode,mobile
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }
  //--------------- Tap Files -----------------//

  addTapFiles = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addTapFacilityFileTable', fields, true)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateTapFiles = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateTapFacilityFileTable', fields, true)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteTapFiles = (facilityImageId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteTapFacilityFileTable', { 
        facilityImageId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  addTapOnboarding = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('addTapFacilityOnboardingTable', fields, true)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  updateTapOnboarding = (fields) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('updateTapFacilityOnboardingTable', fields, true)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  deleteTapOnboarding = (facilityImageId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('deleteTapFacilityOnboardingTable', { 
        facilityImageId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  resetUserPassword = (userId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('resetUserPassword', { 
        userId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  resetUserLevel = (userId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('resetUserLevel', { 
        userId 
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  actionCustomerWallet = (userId,staffId,actionType,amount,ccy,paymentMethod) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('actionCustomerWallet', { 
        userId,staffId,actionType,amount,ccy,paymentMethod
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getWalletTransactionsForFacility = (userId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getWalletTransactionsForFacility', { 
        userId
      }, false)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getReportsTypes = async(facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post("getDashboardReports",{facilityId},false,true)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getDashboardReportDetails= async(facilityId,reportCode,startDate,endDate) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post("getDashboardReportByCode",{facilityId,reportCode,fromDate: startDate,toDate:endDate},false,true)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }

  getTournaments = (facilityId,status) => {
    return new Promise<any>(async (resolve, reject) => {
      await this.http.post('getTournamentList', { 
        status:null
      }, false,true)
      .then(res => {
        const data: any = res;
        resolve(data);
      })
      .catch(async err => {
        reject(err);
      });
    });
  }
}
